import useMemoryHistory from "./useMemoryHistory";
export default function useCurrentProductLine() {
    var _a, _b, _c, _d;
    var history = useMemoryHistory();
    var prevRoute = history.entries[history.index - 1];
    var isHomeRoute = (_a = prevRoute === null || prevRoute === void 0 ? void 0 : prevRoute.pathname) === null || _a === void 0 ? void 0 : _a.includes("home");
    var isAutoRoute = (_b = prevRoute === null || prevRoute === void 0 ? void 0 : prevRoute.pathname) === null || _b === void 0 ? void 0 : _b.includes("auto");
    if (!isHomeRoute && !isAutoRoute) {
        var secondPrevRoute = history.entries[history.index - 2];
        if ((_c = secondPrevRoute === null || secondPrevRoute === void 0 ? void 0 : secondPrevRoute.pathname) === null || _c === void 0 ? void 0 : _c.includes("home")) {
            return "home";
        }
        else if ((_d = secondPrevRoute === null || secondPrevRoute === void 0 ? void 0 : secondPrevRoute.pathname) === null || _d === void 0 ? void 0 : _d.includes("auto")) {
            return "auto";
        }
    }
    return isHomeRoute ? "home" : "auto";
}
